import React, { Component } from 'react';
import './InternalFooter.scss';

export default class InternalFooter extends Component {
  render() {
    return (
      <footer className="footer internal">
        <div className="footer-content">
          <p>
            <a href="http://Justtravelcover.com">Justtravelcover.com</a> is a trading
            style of Just Insurance Agents Limited,
            which is authorised and regulated by the Financial Conduct Authority (FCA)
            number 610022 for General Insurance Distribution activities. Registered in
            England.
            Company No 05399196, Victoria House, Toward Road, Sunderland SR1 2QF.
          </p>
        </div>
      </footer>
    );
  }
}
